import React, { useState, memo } from 'react'
import { Modal } from 'antd'
import store from '@store'
import './style.less'
import { ASRItem, CallStatusString, CallInfo } from 'src/types/ai-assistant'
import { UserInfo } from '@types'
import Title from './components/Title'
import AIContent from './components/AIContent'
import CallWorkbenchContainer from './useCallWorkbenchHook'
import ASRContent from './components/ASRContent'
import CallActionArea from './components/CallActionArea'
import MinimizedWorkbench from './components/MinimizedWorkbench'
import { moduleId } from '@configs'
import { getStaffName } from '@library'
import { ModuleNameMapping } from '@configs/constants'
interface CallWorkbenchModalProps {
  sessionId: string;
  asrList: ASRItem[];
  isCallMute: boolean;
  isCallHold: boolean;
  setIsCallMute: (isCallMute: boolean) => void;
  setIsCallHold: (isCallHold: boolean) => void;
  userInfo: UserInfo;
  callStatus: CallStatusString;
  callInfo: CallInfo;
}

// 迷你工作条的宽度和高度，以及初始偏移量
const minimizedWorkbenchWidth = 288
const minimizedWorkbenchHeight = 126
const minimizedWorkbenchOffsetRight = window.innerWidth / 2 - minimizedWorkbenchWidth / 2
const minimizedWorkbenchOffsetTop = 0

const CallWorkbenchModal = memo(({ callInfo, callStatus, sessionId, asrList, isCallMute, isCallHold, setIsCallMute, setIsCallHold, userInfo }: CallWorkbenchModalProps) => {
  // 添加最小化状态
  const [minimized, setMinimized] = useState(true)
  // 添加最小化工作台的位置状态，使用正确的初始位置计算
  const [minimizedPosition, setMinimizedPosition] = useState({
    x: minimizedWorkbenchOffsetRight,
    y: minimizedWorkbenchOffsetTop,
  })

  // 最小化处理函数
  const handleMinimize = () => {
    setMinimized(true)
  }

  // 还原处理函数
  const handleRestore = () => {
    setMinimized(false)
    // eslint-disable-next-line no-unused-expressions
    window.XSY_TRACK?.trackClick('communication_assistant', {
      content: {
        belong_module: userInfo?.belongModule,
        belong_module_name: ModuleNameMapping[userInfo?.belongModule],
        follower: getStaffName(userInfo.salesName, userInfo.salesNameCh),
        communication_assistant_record_id: callInfo?.recordId,
        communication_assistant_lead_id: callInfo?.leadId,
        communication_assistant_cid: callInfo?.cid,
        communication_assistant_type: 'overallUsage',
      },
    })
  }

  return (
    <>
      {minimized && (
        <MinimizedWorkbench
          callInfo={callInfo}
          callStatus={callStatus}
          sessionId={sessionId}
          isCallMute={isCallMute}
          isCallHold={isCallHold}
          setIsCallMute={setIsCallMute}
          setIsCallHold={setIsCallHold}
          onRestore={handleRestore}
          position={minimizedPosition}
          onPositionChange={setMinimizedPosition}
          width={minimizedWorkbenchWidth}
          height={minimizedWorkbenchHeight}
        />
      )}

      <Modal
        width="90%"
        open={!minimized}
        title={null}
        keyboard={false}
        maskClosable={false}
        mask={false}
        style={{ transition: 'all 0.3s' }}
        bodyStyle={{ height: '82vh', padding: 12 }}
        closable={false}
        footer={null}
      >
        <div className="call-workbench-modal-content">
          <Title callStatus={callStatus} callInfo={callInfo} handleMinimize={handleMinimize} />
          <div className="content">
            <div className="left-content">
              <ASRContent asrList={asrList} callInfo={callInfo} userInfo={userInfo} />
              <div className="call-action-area">
                <CallActionArea callStatus={callStatus} isCallMute={isCallMute} isCallHold={isCallHold} sessionId={sessionId} setIsCallMute={setIsCallMute} setIsCallHold={setIsCallHold} />
              </div>
            </div>
            <div className="right-content">
              <AIContent callInfo={callInfo} userInfo={userInfo} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
})

const CallWorkbench = () => {
  const { isPermissableBelongModule, callInfo, showCallWorkbench, callStatus, sessionId, asrList, isCallMute, isCallHold, setIsCallMute, setIsCallHold, userInfo } = store.useSession()
  const { authPointMap } = store.useGlobal()

  return (isPermissableBelongModule([moduleId.SDR_CLEAN]) && authPointMap?.aiCallingAssistant?.result && userInfo?.useNewT3CCallBar) ? (
    <CallWorkbenchContainer.Provider>
      {showCallWorkbench && <CallWorkbenchModal
      // {true && <CallWorkbenchModal
        callInfo={callInfo}
        callStatus={callStatus}
        sessionId={sessionId}
        asrList={asrList}
        isCallMute={isCallMute}
        isCallHold={isCallHold}
        setIsCallMute={setIsCallMute}
        setIsCallHold={setIsCallHold}
        userInfo={userInfo}
      />}
    </CallWorkbenchContainer.Provider>
  ) : null
}

export default CallWorkbench
